/* Copyright (c) yasc GmbH
 * ALL RIGHTS RESERVED
 * This software is protected by the inclusion of the above copyright
 * notice. This software may not be provided or otherwise made available
 * to, or used by, any other person. No title to or ownership of the
 * software is  hereby  transferred.
 * The information contained in this document is considered the
 * CONFIDENTIAL and PROPRIETARY information of yasc GmbH and may
 * not be disclosed or discussed with anyone who is not employed by
 * yasc GmbH, unless the individual/company
 * (i) has an express need to know such information, and
 * (ii) disclosure of information is subject to the terms of a duly
 * executed Confidentiality and Non-Disclosure Agreement between
 * yasc GmbH and the individual/company.
 */


import {CategorizationStatus, WebFormStatus} from '../../../enums/fibu.enums';
import {BankAccountRes} from '../cp/bank.contract';


export class FBankAccountRes extends BankAccountRes {
    status?: CategorizationStatus;
    error!: {};
}

export class FBankConTestReq {
    bankId!: number;
    credentials: FBankConCreds[] = [];
    testOnly: boolean;

    constructor({
                    bankId = 0,
                    creds = [] as FBankConCreds[],
                    testOnly = true,
                }) {
        this.bankId = bankId;
        this.credentials = creds as FBankConCreds[];
        this.testOnly = testOnly;
    }

}

export class FBankConCreds {
    label!: string;
    value!: string;

    constructor({
                    label = "",
                    value = "",
                }) {
        this.value = value;
        this.label = label;
    }
}

export class FinApiConnectionStatusRes {
    status!: WebFormStatus;
    url!: string;
}